import { render, staticRenderFns } from "./RejectionDialog.vue?vue&type=template&id=58d310f0&"
import script from "./RejectionDialog.vue?vue&type=script&lang=js&"
export * from "./RejectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports